import { Link, router, usePage } from '@inertiajs/react'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {  CallAdd, Location, SearchNormal1 } from 'iconsax-react'
import { Button, ConfigProvider, Form, Input, Select } from 'antd'

import { useTheme } from './ThemeContext'



export default function TopBar() {
    const { currentRoute }: string | any = usePage().props
    const { emergency }: string | any = usePage().props
    const { t , i18n } = useTranslation()

    const [loading, setLoading] = useState(false);
    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const { theme, toggleTheme } = useTheme();

    const [isFixed, setIsFixed] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsFixed(true)
            } else {
                setIsFixed(false)
            }
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const SearchLists = [
        {
            id: 'blogs',
            name: { ar: 'المدونة', en: 'blog' },
            uri: 'blogs'
        },
        {
            id: 'podcasts',
            name: { ar: 'بودكاست', en: 'podcasts' },
            uri: 'podcast'
        },
        {
            id: 'profiledocs',
            name: { ar: 'فريقنا الطبي', en: 'doctors' },
            uri: 'specialdoctor'
        },
        {
            id: 'departments',
            name: { ar: 'الاقسام', en: 'departments' },
            uri: 'department'
        },
        {
            id: 'offers',
            name: { ar: 'العروض', en: 'offers' },
            uri: 'offers'
        },
    ]

    const listSelectSearchList = useMemo(
        () =>
            SearchLists.map((jobcareertype: any) => ({
                value: jobcareertype.id,
                label: jobcareertype.name[i18n.language],
            })),
        [SearchLists, i18n.language]
    )

    const [SearchList, setSearchList] = useState(
        listSelectSearchList.length > 0 ? listSelectSearchList[0].value : ''
    )

    const handleChangeSearchList = (value: string) => {
        setSearchList(value)
    }

    const onFinishSearch = (Values: any) => {
        try {
            setLoading(true)
            router.get(
                route('client.searchwbesite.search', {
                    locale: i18n.language,
                    section: SearchList,
                    search: Values.search,
                })
            )
        } catch (error) {
        } finally {
            setLoading(false)
            setIsSearchVisible(false)
        }
    }

    return (
        <div
            className={`bg-gray-100 py-2 text-black max-w-full border-b border-gray-100 dark:bg-gray-900 dark:text-white dark:border-b-gray-900 ${isFixed ? 'fixed top-0 left-0 w-full  z-[10000]' : ''
                }`}
        >
            <div className="grid grid-cols-2 mx-5 xs:mx-2 xs:grid-cols-1  ">
                <div className="lg:flex items-center xs:my-2 text-sm lg:text-sm gap-4 hidden font-sans">
                    <Link
                        href={route('client.podcast.index', { locale: i18n.language })}
                        className="hover:text-custom-dark-blue dark:hover:text-gray-400"
                    >
                        {' '}
                        {t('topbar.podcast')}{' '}
                    </Link>
                    <Link
                        href={route('client.jobcareer.index')}
                        className="hover:text-custom-dark-blue dark:hover:text-gray-400"
                    >
                        {' '}
                        {t('topbar.jobs')}{' '}
                    </Link>
                    <Link
                        href={route('client.blogs.index', { locale: i18n.language })}
                        className="hover:text-custom-dark-blue dark:hover:text-gray-400"
                    >
                        {' '}
                        {t('topbar.blog')}{' '}
                    </Link>
                    <Link
                        href={route('client.faq.index')}
                        className="hover:text-custom-dark-blue dark:hover:text-gray-400"
                    >
                        {' '}
                        {t('topbar.faq')}{' '}
                    </Link>
                </div>
                <div className="flex justify-end items-center xs:col-span-6 gap-4">
                    <div className="flex items-center xs:col-span-6 ">
                        <SearchNormal1
                            size="22"
                            onClick={() => setIsSearchVisible(!isSearchVisible)}
                            className="cursor-pointer hover:text-custom-dark-blue dark:hover:text-gray-400"
                        />
                        {isSearchVisible && (
                            <div className="ml-4 flex items-center gap-2">
                                <Form name="basic" onFinish={onFinishSearch} className='flex items-center gap-2 '>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionActiveBg: '#e6f4ff',
                                                    optionSelectedBg: '#38b6ff',
                                                    optionSelectedColor: 'white'
                                                },
                                            },
                                            token: {
                                                fontSizeLG: 16,
                                            },
                                        }}
                                    >
                                        <Form.Item
                                        className='!mb-0'
                                        >
                                            <Select
                                                size='small'
                                                className='w-32'
                                                defaultValue={SearchList}
                                                value={SearchList}
                                                placeholder={t('form.listsearch')}
                                                onChange={handleChangeSearchList}
                                                options={listSelectSearchList}
                                            />
                                        </Form.Item>
                                    </ConfigProvider>
                                    <Form.Item
                                        name="search"
                                        rules={[{ required: true }]}
                                        className='!mb-0'
                                    >
                                        <Input
                                            className="w-48 rounded border-[#D9D9D9] dark:bg-[#141414] dark:text-white !p-0"
                                            placeholder={t('form.searchwebsite')}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                    className='!mb-0'
                                    >
                                        <Button type="primary" htmlType="submit" disabled={loading} size="small">
                                            {t('btn.search')}
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        )}
                    </div>

                    <div className="flex items-center xs:col-span-6 font-sans">
                        {
                            emergency &&

                        <a
                            href={`https://wa.me/+966${emergency.number}`}
                            target="_blank"
                            className="flex items-center gap-1 hover:text-custom-dark-blue  dark:hover:text-gray-400"
                        >
                            <CallAdd size="22" />
                            <p>0{emergency.number}</p>
                        </a>
                        }
                    </div>

                    <div className="flex items-center xs:col-span-6 hover:text-custom-dark-blue dark:hover:text-gray-400">
                        <a
                            href="https://www.google.com/maps?q=Dr.+Noor+Mohammed+Khan+General+Hospital+%D9%85%D8%B3%D8%AA%D8%B4%D9%81%D9%89+%D8%A7%D9%84%D8%AF%D9%83%D8%AA%D9%88%D8%B1+%D9%86%D9%88%D8%B1+%D9%85%D8%AD%D9%85%D8%AF+%D8%AE%D8%A7%D9%86+%D8%A7%D9%84%D8%B9%D8%A7%D9%85,+6984+King+Faisal+bin+Abdulaziz+Road,+Al+Baladiyah,+Hafar+Al+Batin+39921&ftid=0x3fd740ac5200fc2d:0x7a460a9890985a39&entry=gps&lucs=,94242595,94224825,94227247,94227248,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_ep=CAISEjI0LjUwLjAuNzA0NDI3ODkxMBgAINeCAypjLDk0MjQyNTk1LDk0MjI0ODI1LDk0MjI3MjQ3LDk0MjI3MjQ4LDQ3MDcxNzA0LDQ3MDY5NTA4LDk0MjE4NjQxLDk0MjAzMDE5LDQ3MDg0MzA0LDk0MjA4NDU4LDk0MjA4NDQ3QgJTQQ%3D%3D&g_st=iwb"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Location size="22" />
                        </a>
                    </div>
                    <div className="flex items-center xs:col-span-6">
                        <Link
                            href={route(currentRoute, { ...route().params, locale: 'en' })}
                        >
                            <Button
                                className={`${i18n.language === 'en'
                                    ? 'bg-custom-dark-blue !text-white hover:!bg-custom-dark-blue'
                                    : ''
                                    }  rounded-full font-sans dark:!border-white`}
                            >
                                English
                            </Button>
                        </Link>
                        <Link
                            href={route(currentRoute, { ...route().params, locale: 'ar' })}
                        >
                            <Button
                                className={`${i18n.language === 'ar'
                                    ? ' bg-custom-dark-blue !text-white hover:!bg-custom-dark-blue'
                                    : ''
                                    } mx-2 rounded-full font-sans dark:!border-white`}
                            >
                                العربية
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    )
}